import React, { useState, useEffect } from "react";
import "./user-details.css";
import DataTable from "react-data-table-component";
import axios from "../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { getAffiliates } from "../../../axios/affiliate.axios";
import moment from "moment";
import { CSVLink } from "react-csv";
import { Button } from "react-bootstrap";
import { adminConfig } from "../../../utils/adminConfig";

const columns = [
  {
    name: "ID",
    selector: (row) => row.id,
    sortable: true,
    width: "150px",
  },
  {
    name: "Email",
    selector: (row) => row.email,
    sortable: true,
    width: "300px",
  },
  {
    name: "Name",
    selector: (row) => row.name,
    sortable: true,
    width: "200px",
  },
  {
    name: "Phone",
    selector: (row) => row.phone,
    width: "200px",
  },
  {
    name: "Plan Name",
    selector: ({ packageDetails }) => packageDetails?.stripePlanName,
    width: "300px",
  },
  {
    name: "Plan Price",
    selector: ({ packageDetails }) =>
      packageDetails?.packagePrice ? "$" + packageDetails?.packagePrice : "",
    width: "100px",
  },
  {
    name: "Plan Expire",
    selector: ({ packageDetails }) => packageDetails?.expireDate,
    width: "100px",
  },
  {
    name: "Plan Status",
    selector: ({ isSubscriptionCanceled }) =>
      isSubscriptionCanceled ? "Canceled" : "Active",
    width: "100px",
  },
  {
    name: "Login Date",
    // selector: ({ sessionDetails }) =>
    //   sessionDetails.loginDate
    //     ? moment(sessionDetails.loginDate).format("MM-DD-YYYY")
    //     : "",
    selector: () => "",
    width: "100px",
  },
  {
    name: "Arrivia User Id",
    selector: (row) => row.arriviaUserId,
    sortable: true,
    width: "100px",
  },
  {
    name: "Affiliate",
    selector: (row) =>
      row.affiliateDetails[0] ? row.affiliateDetails[0].name : "",
    sortable: true,
    width: "200px",
  },
  {
    name: "Created At",
    selector: (row) => moment(row.createdAt).format("MM-DD-YYYY"),
    sortable: true,
    width: "200px",
  },
  // {
  //   name: "status",
  //   selector: (row) => row.status,
  //   sortable: true,
  //   width: "200px",
  // },
];

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};

const UserDetailsAffiliates = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [affiliateList, setAffiliateList] = useState([]);
  const [affiliate, setAffiliate] = useState("");
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const [pagination, setPagination] = useState({
    limit: 5,
    page: 1,
    totalPage: 7,
    totalRows: 10,
  });

  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [memberCalling, setMemberCalling] = useState(false);
  const [csvData, setCsvData] = useState([]);

  const handlePerRowsChange = (newPerPage) => {
    setLimit(newPerPage);

    setPage(1);
  };

  const getAffiliateList = async () => {
    let list = await getAffiliates(undefined, {});
    list = list.map((elem) => {
      return {
        id: elem.id,
        code: elem.code,
        text: elem.name,
      };
    });
    setAffiliateList(list);
  };

  const getMembers = async () => {
    setLoading(true);
    try {
      await axios
        .get(
          `/get-tvi-users-affiliate/?limit=${limit}&page=${page}&affiliate=${affiliate}&search=${search}`,
          adminConfig()
        )
        .then((res) => {
          setLoading(false);

          if (res.data.status) {
            setMembers(res.data.data);
            setPagination(res.data.pagination);
          } else {
            message.error("failed fetching member");
          }
        })
        .catch((err) => {
          setLoading(false);
          console.error(err);
        });
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const changePage = (newPage) => {
    setPage(newPage);
  };

  const changeAffiliate = (event) => {
    setAffiliate(event.target.value);
    setPage(1);
  };

  useEffect(() => {
    if (!memberCalling) {
      getAffiliateList();
      setMemberCalling(true);
    }
    getMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [affiliate, limit, page, search]);

  const exportCSV = () => {
    setLoading(true);
    axios
      .get(
        `/get-csv-tvi-users-affiliate/?affiliate=${affiliate}&search=${search}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const csvData = res.data.data.map((member) => ({
            ID: member.id,
            Email: member.email,
            Name: member.name,
            Phone: member.phone,
            PlanName: member.packageDetails?.stripePlanName,
            PlanPrice: member.packageDetails?.packagePrice
              ? "$" + member.packageDetails?.packagePrice
              : "",
            PlanExpire: member.packageDetails?.expireDate,
            PlanStatus: member.isSubscriptionCanceled ? "Canceled" : "Active",
            LoginDate: "",
            arriviaUserId: member.arriviaUserId,
            Affiliate: member.affiliateDetails[0]
              ? member.affiliateDetails[0].name
              : "",
            createdAt: moment(member.date).format("MM-DD-YYYY"),
          }));
          setCsvData(csvData);
          setTimeout(() => {
            document.getElementById("csv-download-link").click();
            setLoading(false);
          }, 2000);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const csvHeaders = [
    { label: "ID", key: "ID" },
    { label: "Email", key: "Email" },
    { label: "Name", key: "Name" },
    { label: "Phone", key: "Phone" },
    { label: "Plan Name", key: "PlanName" },
    { label: "Plan Price", key: "PlanPrice" },
    { label: "Plan Expire", key: "PlanExpire" },
    { label: "Plan Status", key: "PlanStatus" },
    { label: "Login Date", key: "LoginDate" },
    { label: "Arrivia User Id", key: "arriviaUserId" },
    { label: "Affiliate", key: "Affiliate" },
    { label: "createdAt", key: "createdAt" },
  ];

  return (
    // <div>
    //     <HeaderPart />
    //     <div className='main_cont'>
    //         <LeftpanelAdmin />
    <LoadingOverlay spinner active={loading} text="Loading...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <div className="ar_count_card d-flex">
                  <h3>Affiliate Users List</h3>
                  <div className="ar_count">{pagination.totalRows}</div>
                </div>

                <div className="filter_section">
                  <div className="input-group filter_fields">
                    <div className="search_field">
                      <input
                        placeholder="Type name or email"
                        type="text"
                        id="form1"
                        className="form-control"
                        onChange={(e) => {
                          setQuery(e.target.value);
                        }}
                        value={query}
                      />
                    </div>

                    <Button
                      className="search_button"
                      variant="primary"
                      onClick={() => {
                        setSearch(query);
                        setPage(1);
                      }}
                    >
                      Search
                    </Button>

                    <Button
                      className="search_button"
                      variant="secondary"
                      disabled={!search}
                      onClick={() => {
                        setSearch("");
                        setQuery("");
                        setPage(1);
                      }}
                    >
                      Clear Filter
                    </Button>
                  </div>
                  <div className="filter_btns">
                    <Button
                      className="btn btn-primary search_button"
                      onClick={exportCSV}
                    >
                      Export CSV
                    </Button>
                    <CSVLink
                      data={csvData}
                      headers={csvHeaders}
                      filename={`affiliate_users.csv`}
                      className="hidden"
                      id="csv-download-link"
                      target="_blank"
                    />
                  </div>

                  <select
                    className="form-control  col-md-3 p-1"
                    onChange={changeAffiliate}
                  >
                    <option value={""}> Select Affiliates</option>
                    {affiliateList &&
                      affiliateList.map((elem) => {
                        return (
                          <option id={elem.id} value={elem.code}>
                            {elem.text}
                          </option>
                        );
                      })}
                  </select>
                </div>

                <DataTable
                  columns={columns}
                  data={members}
                  pagination
                  striped
                  responsive
                  customStyles={customStyles}
                  subHeaderAlign="right"
                  subHeaderWrap
                  paginationDefaultPage={page}
                  paginationServer
                  paginationTotalRows={pagination.totalRows}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[10, 15, 20, 40]}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={changePage}
                  progressComponent={<CustomLoader />}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
    //     </div>
    // </div>
  );
};
const CustomLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>Loading...</div>
  </div>
);

export default UserDetailsAffiliates;
